import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { SearchFasteningTypesResponse, UpdateFasteningTypeBody } from "./types/fasteningTypes";

export const useDeckFasteningTypesApi = () => {
  const crud = createAdminCrudApi<SearchFasteningTypesResponse, never, UpdateFasteningTypeBody>(
    useApi(),
    DECK_ADMIN_URL,
    "fastening_types",
  );

  return {
    useDeckFasteningTypes: crud.useSearch,
    getDeckFasteningTypes: crud.search,
    updateDeckFasteningType: crud.update,
    generateUploadImageUrl: crud.generateUploadImageUrl,
    uploadImage: crud.uploadImage,
  };
};

export default useDeckFasteningTypesApi;
